import { MapContainer, Marker, TileLayer, Popup, useMap } from "react-leaflet";
// import 'leaflet/dist/leaflet.css';
import L, { map } from 'leaflet'
import { useEffect, useState, useCallback } from "react";
import ReactLeafletKml from 'react-leaflet-kml'
import { LatLngExpression } from "leaflet";
import KmLLayer from "./KmlLayer";
import KMLData from "./KmlLayer";
import ChackOnOf from "./ChackOnOf";
import SearchBox from "./SearchBox";
import ApiService from "../../services/apiService";
import { toast } from "react-toastify";
import { useMemo } from "react";
import debounce from 'lodash/debounce';

import SearchMap from "../svg/SearchMap";
import { usePagination } from "../../hooks/usePagination";


const MapView = () => {

  const [chack, setchack] = useState<any>();
  const [showInput, setShowInput] = useState(false)
  const [id, setId] = useState<any>()

  const position: LatLngExpression = [20.1311504495924, 85.1703809925077]
  const [highlightLocation, setHighlightLocation] = useState<any>(null);

  const arrowIcon = L.divIcon({
    className: "custom-arrow-marker",
    html: `
      <div class="arrow-wrapper">
        <div class="arrow-pulse"></div>
        <div class="arrow-icon">📍</div>
      </div>
    `,
    iconSize: [50, 50],
    iconAnchor: [25, 50],
  });



  // This component will control the zoom to the selected chack's location

  
const ZoomToInitialPosition = (selectedId: any, selectedChack: any) => {
  setchack(selectedChack);
  setId(selectedId);
  setHighlightLocation(selectedChack);

  setTimeout(() => {
    setHighlightLocation(null);
    
  }, 3000); // arrow 2sec dikhega
};

  // const [kml, setKml] = useState<XMLDocument | null>(null);

  const ZommedMap = () => {
    const map = useMap(); // This gives you the map instance

    useEffect(() => {
      if (chack) {
        map.flyTo([chack.lat, chack.long], 16); // Zoom to selected chack position with zoom level 13
      }
    }, [ chack]); // Re-run when dropdown or selected chack changes
    return null;
  }


  useEffect(() => {


    L.Icon.Default.mergeOptions({
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });


  }, []);

  const googleHybrid = useMemo(() => {
    return L.tileLayer('http://{s}.google.com/vt?lyrs=s,h&x={x}&y={y}&z={z}', {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    });
  }, []);


  function AddGoogleMapsLayer() {
    const map = useMap();
    useEffect(() => {
      googleHybrid.addTo(map); // Add Google Maps tile layer to the map
      return () => {
        googleHybrid.removeFrom(map); // Cleanup when component unmounts
      };
    }, [map]); // Only run on map change
    return null; // This component doesn't render anything to the UI
  }

  return (
    <div style={{ position: 'relative', height: '100vh' }}>
      <MapContainer center={position} zoom={50} scrollWheelZoom={true} style={{ height: "calc(100vh - 80px)", minHeight: '100vh' }}>
      {highlightLocation && (
    <Marker
      position={[
        highlightLocation.lat + 0.00030,
        highlightLocation.long,
      ]}
      icon={arrowIcon}
    />
  )}
        <AddGoogleMapsLayer />
        <KmLLayer id={id} />
        <ZommedMap />
      </MapContainer>

      {<SearchBox
        
        ZoomToInitialPosition={ZoomToInitialPosition}


      />}

      

      
    </div>
  )
}
export default MapView;